import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Button, Flex } from '@chakra-ui/react';
import GameSockets from 'utils/GameSockets';
import { observer } from 'mobx-react';
import { useStores } from 'hooks/useStores';
import Table from 'components/Table';
import { IconButton } from '@chakra-ui/react';
import { CgTrash, CgUserList } from 'react-icons/cg';
import { ImEye } from 'react-icons/im';
import PlayersListModal from './PlayersListModal';
import { newRoomModal } from 'components/NewRoomModal';

const GamePanel = ({ shortName, name }) => {
  const socket = useRef(null);

  const {
    gamesStore: {
      gameInfo,
      fetchRoomPlayers,
      playersModalRoomId,
      setPlayerModalRoomId,
      closeEmptyRoom
    },
  } = useStores();

  useEffect(() => {
    socket.current = new GameSockets(shortName);

    return () => {
      socket.current?.closeSocket();
    };
  }, []);

  const [isOpen, setIsOpen] = useState(false);

  const onPlayersListOpen = async roomId => {
    await fetchRoomPlayers(shortName, roomId);
  };

  const onCloseEmptyRoom = async roomId => {
    await closeEmptyRoom(shortName, roomId);
  };

  const onWatchRoom = roomId => {
    socket.current?.joinIntoRoom(roomId);
  };

  const columns = useMemo(
    () => [
      {
        Header: 'Id',
        accessor: 'id',
      },
      {
        Header: 'Private',
        accessor: r => r.isPrivate.toString(),
      },
      {
        Header: 'Players',
        accessor: 'players',
      },
      {
        Header: 'Slots',
        accessor: 'Slots',
      },
      {
        Header: 'SlotsOccupied',
        accessor: 'slotsOccupied',
      },
      {
        Header: 'Watch Players',
        accessor: 'id',
        id: 'watch-players',
        Cell: ({ value }) => (
          <IconButton
            variant="ghost"
            icon={<CgUserList />}
            onClick={() => onPlayersListOpen(value)}
          />
        ),
      },
      {
        Header: 'Subscribe room',
        accessor: 'id',
        id: 'subscribe',
        Cell: ({ value }) => (
          <IconButton
            variant="ghost"
            icon={<ImEye />}
            onClick={() => onWatchRoom(value)}
          />
        ),
      },
      {
        Header: 'Close',
        accessor: 'id',
        id: 'close-eoom',
        Cell: ({ value }) => (
          <IconButton
            variant="ghost"
            icon={<CgTrash />}
            onClick={() => onCloseEmptyRoom(value)}
          />
        ),
      },
    ],
    []
  );

  const { Players, Rooms } = gameInfo;

  const NewRoomModal = newRoomModal[shortName];

  return (
    <div>
      <Flex justifyContent="flex-end" my={2}>
        <Button
          onClick={() => setIsOpen(true)}
          colorScheme="green"
          variant="solid"
          disabled={!NewRoomModal}
        >
          Add room
        </Button>
      </Flex>
      <Table
        {...{
          columns,
          data: Rooms,
        }}
      />
      <PlayersListModal
        {...{
          shortName,
          isOpen: !!playersModalRoomId,
          onClose: () => setPlayerModalRoomId(null),
          roomId: playersModalRoomId,
        }}
      />

      {NewRoomModal && (
        <NewRoomModal
          {...{
            show: isOpen,
            handleClose: () => setIsOpen(false),
            shortName,
          }}
        />
      )}
    </div>
  );
};

export default observer(GamePanel);
